import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Smile } from "lucide-react";
import { useEditorRef } from "platejs/react";
import { memo, useCallback, useState } from "react";
import { RedoButton } from "../../arbiter-components/buttons/redo-button";
import {
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "../ui/dropdown-menu";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useToolbarOverflow } from "./toolbar-overflow";

interface EmojiData {
  native: string;
}

export const EmojiToolbarButton = memo(function EmojiToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = useState(false);

  const handleSelect = useCallback(
    (emoji: EmojiData) => {
      editor.tf.insertText(emoji.native);
      editor.tf.focus();
      setOpen(false);
    },
    [editor],
  );

  const { isOverflow } = useToolbarOverflow();

  if (isOverflow) {
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>
          <Smile />
          Emoji
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent className="border-none p-0 shadow-none">
          <Picker
            data={data}
            onEmojiSelect={handleSelect}
            previewPosition="none"
            skinTonePosition="none"
            theme="light"
          />
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    );
  }

  return (
    <Popover modal={false} onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <div>
          <RedoButton hierarchy="tertiary" IconLeading={Smile} size="sm" />
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-auto border-none p-0 shadow-none"
      >
        <Picker
          data={data}
          onEmojiSelect={handleSelect}
          previewPosition="none"
          skinTonePosition="none"
          theme="light"
        />
      </PopoverContent>
    </Popover>
  );
});
